import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isDirty } from 'redux-form';
import { jsxActions as commonPdfLabelSettingsViewActions} from '../../../../actions/Administration/SettingsPage/commonPdfLabelSettingsViewActions';
import { jsxActions as settingsPageActions} from '../../../../actions/Administration/SettingsPage/settingsPageActions';
import SpoolPdfLabelSettingsView from '../../../../components/Administration/SettingsPage/PdfLabelSettings/SpoolPdfLabelSettingsView/spoolPdfLabelSettingsView';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(commonPdfLabelSettingsViewActions, dispatch),
      settingsPageActions : bindActionCreators(settingsPageActions, dispatch)
    }
  }
}

let SpoolPdfLabelSettingsViewContainer = connect(
  (state) => {
    return {
      sData: state.administration.getIn(['settingsPage', 'commonPdfLabelSettingsView']),
      isDirty: isDirty('pdfLabelSettingsForm')(state),
    };
  },

  mapDispatchToProps
)(SpoolPdfLabelSettingsView);

export default SpoolPdfLabelSettingsViewContainer;



